import './style.css';
import { Game } from './game/Game';

// Early touch flag so menu CSS applies before Game boots
const isTouch =
  window.matchMedia('(pointer: coarse)').matches ||
  window.matchMedia('(max-width: 900px)').matches ||
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0;
if (isTouch) document.body.classList.add('is-touch');

const canvas = document.getElementById('c') as HTMLCanvasElement;
const progress = document.getElementById('progress-bar')!;

const game = new Game(canvas);

game
  .init((n) => {
    progress.style.width = `${Math.round(n * 100)}%`;
  })
  .catch((err) => {
    console.error(err);
    const sub = document.querySelector('#loading .sub');
    if (sub) sub.textContent = 'Failed to start WebGL. Try another browser.';
  });

// Hot module hygiene
if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
